import { prop, propOr } from 'ramda';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';

import { REDUCER_NAME } from './slice';

const getRoot = prop([REDUCER_NAME]);

export const getSubordinateUsers = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'subordinateUsers'));
export const getSuperiorUsers = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'superiorUsers'));
export const getUserDataFromDBFlag = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'userDataFromDB'));
